var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('horizontal-nav',{attrs:{"items":_vm.items,"set_view":"","show_display":false},on:{"setSelected":_vm.setSelected}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }